import React from 'react';
import PropTypes from 'prop-types';

export class ContactItem extends React.Component {
  constructor(props){
    super(props);

    this.title = this.title.bind(this);
    this.fullName = this.fullName.bind(this);
    this.phone = this.phone.bind(this);
    this.email = this.email.bind(this);
  }

  title() {
    if (this.props.title) {
      return <li className="title is-6">{this.props.title}</li>;
    }
  }

  fullName() {
    const fullName = `${this.props.first_name} ${this.props.last_name}`;

    if (this.props.first_name ||  this.props.last_name) {
      return <li className="contact-panel__name">{fullName}</li>;
    }
  }

  phone() {
    const phone = (this.props.phone ||
                   this.props.cell_phone ||
                   this.props.work_phone);
    if (phone) {
      const formattedPhone = `${phone}`.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (formattedPhone){
        return <li className="contact-panel__phone">({formattedPhone[1]}) {formattedPhone[2]}-{formattedPhone[3]}</li>;
      } else {
        return <li className="contact-panel__phone">{phone}</li>;
      }
    }
  }

  email() {
    const email = this.props.email;
    if (email) {
      return <li className="contact-panel__email"><a href={`mailto:${email}`}>{email}</a></li>;
    }
  }

  render() {
    return (
      <ul className="contact-panel__contact">
        {this.title()}
        {this.fullName()}
        {this.phone()}
        {this.email()}
      </ul>
    );
  }
}

ContactItem.defaultProps = {
  work_phone: "8882449099",
  email: "customersupport@forwardfinancing.com"
};

ContactItem.propTypes = {
  title: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  phone: PropTypes.string,
  cell_phone: PropTypes.string,
  work_phone: PropTypes.string,
  email: PropTypes.string.isRequired
};
